import Phaser from "phaser";
import { Direction } from "../core/model";

export class KeyboardControls {
  private spaceKey: Phaser.Input.Keyboard.Key;
  private keydownHandler: (event: KeyboardEvent) => void;

  constructor(
    private readonly scene: Phaser.Scene,
    private readonly canHandleInput: () => boolean,
    private readonly onDirection: (dir: Direction) => void
  ) {
    this.spaceKey = this.scene.input.keyboard!.addKey(
      Phaser.Input.Keyboard.KeyCodes.SPACE
    );

    this.keydownHandler = (event: KeyboardEvent) => {
      if (!this.canHandleInput()) return;

      switch (event.code) {
        case "ArrowLeft":
          this.onDirection({ dx: -1, dy: 0 });
          break;
        case "ArrowRight":
          this.onDirection({ dx: 1, dy: 0 });
          break;
        case "ArrowUp":
          this.onDirection({ dx: 0, dy: -1 });
          break;
        case "ArrowDown":
          this.onDirection({ dx: 0, dy: 1 });
          break;
        default:
          break;
      }
    };

    this.scene.input.keyboard?.on("keydown", this.keydownHandler, this);
  }

  wasSpaceJustDown(): boolean {
    return Phaser.Input.Keyboard.JustDown(this.spaceKey);
  }

  destroy(): void {
    this.scene.input.keyboard?.off("keydown", this.keydownHandler, this);
  }
}
